import * as service from './checklistlanding.service.js'
export default {

  data() {
    return {
      //FG - FOOF - ADDED STUFF BELOW WHEN I SWITCHED TO v-client-table
      checklist_list_columns: [
        'ModifiedOn', 'LocationName', 'PoolName', 'ChecklistName',
        'ModifiedOnLocationPoolChecklistNames', 'CompletionAddedBy',
        'Completion', 'AddedBy',
        'Actions'],
      attachmentcolor: 'gray',
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          ModifiedOn: 'Last saved',
          LocationName: 'Facility',
          PoolName: 'Venue',
          ChecklistName: 'Checklist Name',
          ModifiedOnLocationPoolChecklistNames: ' ',
          CompletionAddedBy: ' ',
          Completion:'% Complete',
          
          AddedBy: 'Submitted by',
          Actions: ' '
        },

        columnsClasses: {
          "ModifiedOn":"hydroware-datetime-column hidden-xs hidden-sm",
          "LocationName":"hydroware-facility-column hidden-xs hidden-sm",
          "PoolName":"hydroware-venue-column hidden-xs hidden-sm",
          "ChecklistName":"hydroware-checklistname-column hidden-xs hidden-sm",
          "ModifiedOnLocationPoolChecklistNames":"hydroware-label-in-column hidden-md hidden-lg hidden-xl",
          "CompletionAddedBy":"hydroware-label-in-column hidden-md hidden-lg hidden-xl",
          "Completion": "hidden-xs hidden-sm",
          "AddedBy":"hydroware-facility-column hidden-xs hidden-sm"
        },
        //FG - FOOF - use the bootstrap class 
        //(i.e. hidden-x etc...just above) instead of the v-client-table values (i.e. mox-mobileL)     
        //columnsDisplay: {
        //},

        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: [],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      //FG - FOOF - ADDED STUFF ABOVE WHEN I SWITCHED TO v-client-table







      showchecklist: false,
      labelPosition: 'top',
      locationid: '',
      CopyChecklistRun: [],
      filterlistvalue: '',
      poolname: '',
      isediting: false,

      isAddingOrEditing:"", //FG - FOOF - After Cert - First Release Security (7)

      currentchecklist: [],
      ischecklistrunning: false,
      checklistviewmodel: [],
      islocationselected: true,
      ChecklistRun: [],
      StateCode: '',
      poolName: '',
      filterpoolid: [],
      locationId: '',
      locations: [],
      isActive: false,
      Copyitem: [],
      List: [],
      locationName: '',
      pools: [],
      filterPools: [],
      checklistcheck: {
        location: '',
        pool: '',
        municipality: '',
        checklisttype: ''
      }

    }
  },

  mounted() {

    this.isActive = 'All'
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationid = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''

      if (context.locationid) {
        context.GetChecklistRun()
      }

      // alert(JSON.stringify(data))

    })

    this.$router.app.$on('emittedpool_obj', (data) => {
      //setTimeout(function () {
        context.filterpoolid = data.PoolId ? data.PoolId : ''

      //}, 100)


      context.poolName = data.PoolName ? '(Pool : ' + data.PoolName + ')' : ''
      if (context.filterpoolid) {
        context.GetChecklistRun()

      }


      // alert(JSON.stringify(data))

    })


    this.islocationselected = true
    // this.getchecklist(0);
    this.getpools(0)
    this.getLocations()

  },

  methods: {
    addnewcheckliststart() {

      this.isAddingOrEditing="A"; //FG - FOOF - After Cert - First Release Security (7)

      this.islocationselected = false
      this.showchecklist = false

      this.checklistcheck = {
        location: '',
        pool: '',
        municipality: '',
        checklisttype: ''
      }
      this.$refs['checklistcheck'].resetFields()
      $('#CheckListWizard').modal('show')

    },
    getchecklist(locationid) {
      let context = this
      service.GetChecklist(locationid).then(function (response) {


        context.List = response.Checklist

        context.StateCode = response.StateCode
        if (context.Copyitem.length > 0) {

        } else {
          context.Copyitem = deepcopy(response.Checklist)
        }

      }, (error) => {
        this.$notify({

          title: 'Error',

          message: 'CHECKLIST - 1 error while submit!!',

          type: 'error'

        })
      })
    },
    GetChecklistRun() {
      //FG - FOOF - After Cert - First Release (7) - don't try to get a checklist if the user 
      //does not have access to the page. It will trigger the error condition in the code below
      if(this.$hydrowareSecurityJS.canDisplay_A('MAHCchecklist')==false) return;
      //alert("loc: " + this.locationid + "/  + filterpoolid: " + this.filterpoolid);
      let context = this
      loader.startLoader()
        //this.locationid = this.locationid ? this.locationid : 0
        this.filterpoolid = this.filterpoolid ? this.filterpoolid : 0
      if (this.filterpoolid != null) {
        service.GetChecklistRun(this.locationid, this.filterpoolid).then(function (response) {

        //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
        if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
          context.ChecklistRun = []          
          context.CopyChecklistRun = []
          loader.stopLoader()
          return;
        }
        //FG - FOOF - After Cert - First Release Security (7) - above

          loader.stopLoader()
          context.ChecklistRun = response
          context.CopyChecklistRun = deepcopy(context.ChecklistRun)
          tooltip.startTooltip(50)
        }, (error) => {
          loader.stopLoader()
          context.$notify({

            title: 'Error',

            message: 'CHECKLIST -2 error while submit!!',

            type: 'error'

          })
        })
      }

    },
    cancelled(data) {
      if (data) {
        this.ischecklistrunning = false

        if (window.globallocid) {

          this.GetChecklistRun(window.globallocid)
        } else {
          this.GetChecklistRun(0)
        }

      }

    },
    selectstat(btnname) {

      this.isActive = btnname
      if (btnname == 'All') {

        this.List = this.Copyitem
      } else {

        function checkData(data) {
          return data.StandardCodeName == btnname
        }

        var checklist1 = this.Copyitem.filter(checkData)

        this.List = checklist1

      }

    },
    getLocations() {
      let context = this

      service.GetLocations().then(function (response) {

        context.locations = response

        if (context.locations) {
          context.getchecklist(context.locations[0].LocationId)
        }

        if (context.locations.length == 1 && !context.isInvoked) {

          context.locationname = context.locations[0].LocationName
        }

      }, (error) => {

      })

    },

    filterGetPools(locationid) {
      this.filterpoolid = ''
      let context = this

      if (locationid || locationid == 0) {

        service.GetPools(locationid).then(function (response) {
          context.filterPools = response

        }, (error) => {
          context.$notify({

            title: 'Error',

            message: error,

            type: 'error'

          })
        })
      } else {
        context.filterPools = []
      }
    },

    getpools(locationid) {

      let context = this

      if (locationid || locationid == 0) {

        service.GetPools(locationid).then(function (response) {
          context.pools = response

        }, (error) => {
          context.$notify({

            title: 'Error',

            message: error,

            type: 'error'

          })
        })
      } else {
        context.pools = []
      }

    },

    handleRun(index, row) {
      $('#CheckListWizard').modal('hide')

      this.checklistviewmodel = {
        CheckListId: row.Id,
        Name: row.Name,
        StandardCodeId: row.StandardCodeId,
        StandardCodeName: row.StandardCodeName,
        LocationID: this.checklistcheck.location,
        PoolID: this.checklistcheck.pool,
        LocationName: this.locationname,
        PoolName: this.poolname,
        Checklistname: row.Name

      }
      this.ischecklistrunning = true
      this.isediting = false
      
      this.isAddingOrEditing="A"; //FG - FOOF - After Cert - First Release Security (7)

    },
    //RunChecklist(index, row) {
    RunChecklist(row) {
      let checklistRunId = row.Id

      this.checklistviewmodel = {
        Id: row.Id,
        Name: row.ChecklistName,
        ChecklistId: row.ChecklistId,
        StandardCodeId: row.StandardCodeId,
        StandardCodeName: row.StandardCodeName,
        LocationID: this.checklistcheck.location,
        PoolId: row.PoolId,
        LocationName: row.LocationName,
        PoolName: row.PoolName,
        Checklistname: row.ChecklistName

      }

      this.ischecklistrunning = true
      this.isediting = true

      this.isAddingOrEditing="E"; //FG - FOOF - After Cert - First Release Security (7)

    }
  },
  watch: {
    'checklistcheck.location': function (locationid) {
      this.getchecklist(locationid)
      this.checklistcheck.pool = ''
      this.getpools(locationid)
      if (this.locations) {
        for (var i = 0; i < this.locations.length; i++) {
          if (this.locations[i].LocationId == locationid) {
            this.locationname = this.locations[i].LocationName

            break
          }
        }
      }

    },
    'checklistcheck.pool': function (poolid) {
      if (poolid) {
        if (this.pools) {

          this.islocationselected = true
          for (var i = 0; i < this.pools.length; i++) {
            if (this.pools[i].PoolId == poolid) {
              this.poolname = this.pools[i].PoolName
              break
            }
          }
        }

      }
    },
    filterlistvalue: function (name) {

      if (name == 'All') {
        this.ChecklistRun = this.CopyChecklistRun
      } else {
        function checkData(data) {
          return data.ChecklistName == name
        }

        var checklist1 = this.CopyChecklistRun.filter(checkData)
        this.ChecklistRun = checklist1
      }

    },
    locationid: function (locationid) {
      this.filterlistvalue = 'All'
      this.ChecklistRun = this.CopyChecklistRun
      this.islocationselected = true
      this.getchecklist(locationid)
      this.getpools(locationid)
      this.GetChecklistRun(locationid)
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/checklistLanding/checklistlanding.controller.js